module.exports = __webpack_public_path__ + "img/patient-skeleton.164c6cc2.png";